import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

const ITEMS = [
  { type: "section", label: "Flujo de Compra" },
  { label: "Órdenes de Compra",      icon: "fas fa-shopping-basket", color: "#3b82f6", bg: "#eff6ff", href: "/ListadoOrdenesCompra",      desc: "Gestión de órdenes",             perm: "menu_oc"            },
  { label: "Recepciones Bodega USA",  icon: "fas fa-plane-arrival",   color: "#f97316", bg: "#fff7ed", href: "/ListadoRecepcionesLaredo",   desc: "Llegadas a bodega USA",          perm: "menu_compras"       },
  { label: "Entradas",               icon: "fas fa-cart-plus",       color: "#10b981", bg: "#f0fdf4", href: "/ListadoCompras",             desc: "Entradas a almacén México",      perm: "menu_compras"       },

  { type: "section", label: "Seguimiento de Pedidos" },
  { label: "Pend. Llegar a Bodega USA", icon: "fas fa-ship",          color: "#6366f1", bg: "#eef2ff", href: "/ListadoPendLaredo",          desc: "Pendiente de proveedor→Bodega USA", perm: "menu_compras"    },
  { label: "Pend. Recibir en Mx",    icon: "fas fa-inbox",           color: "#f59e0b", bg: "#fffbeb", href: "/ListadoPendRecibir",         desc: "Pendiente Bodega USA→México",    perm: "menu_compras"       },

  { type: "section", label: "Planeación de Reabasto" },
  { label: "Reabasto",          icon: "fas fa-warehouse",       color: "#8b5cf6", bg: "#f5f3ff", href: "/ListadoReabasto",        desc: "Análisis de reabasto",    perm: "inventarios_costos" },
  { label: "Sugerido Reabasto", icon: "fas fa-sync",            color: "#6366f1", bg: "#eef2ff", href: "/ListadoRotacion",        desc: "Rotación y reposición",   perm: "inventarios_costos" },

  { type: "section", label: "Seguimiento" },
  { label: "Tracking Compras",  icon: "fas fa-search",          color: "#0ea5e9", bg: "#f0f9ff", href: "/ListadoTrackingCompras",   desc: "Seguimiento de compras",     perm: "inventarios_costos" },

  { type: "section", label: "Catálogos" },
  { label: "Proveedores",       icon: "fas fa-dolly",           color: "#64748b", bg: "#f8fafc", href: "/Proveedores",              desc: "Catálogo de proveedores",    perm: "menu_proveedores"   },
  { label: "Destinos",          icon: "fas fa-map-marker-alt",  color: "#e11d48", bg: "#fff1f2", href: "/ListadoDestinosCompra",    desc: "Destinos de importación",    perm: "menu_oc"            },
];

function BotonesCompras() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-shopping-cart" color="#3b82f6" bg="#eff6ff" title="Compras" subtitle="Órdenes de compra y entradas de mercancía" />
        {user.menu_compras ? (
          <div className="row">
            {ITEMS.map((r, i) =>
              r.type === "section"
                ? <MenuSection key={i} title={r.label} />
                : <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
            )}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesCompras;
